import { Helmet } from 'react-helmet';
import TeamCard from '../components/TeamCard';
import SectionCTA from '../components/SectionCTA';
import RiskDisclosure from '../components/RiskDisclosure';
import Surface from '../components/ui/Surface';
import { teamMembers } from '../data/content';

export default function AboutPage() {
  return (
    <main>
      <Helmet>
        <title>About | Carter Asset Management</title>
      </Helmet>
      <section className="section-container section-spacing">
        <div className="max-w-3xl space-y-6">
          <p className="text-sm font-semibold uppercase tracking-wide text-cam-blue/70">About</p>
          <h1 className="text-4xl md:text-5xl font-semibold tracking-tight text-cam-blue">Independent, fiduciary guidance rooted in disciplined execution.</h1>
          <p className="text-base text-slate-600">
            Carter Asset Management is an independent wealth partner helping families and founders align money with what matters—through thoughtful planning, disciplined investing, and proactive tax strategy.
          </p>
        </div>
      </section>
      <section className="section-container pb-16">
        <div className="grid gap-6 md:gap-8 lg:grid-cols-3">
          {teamMembers.map((member) => (
            <TeamCard key={member.name} {...member} />
          ))}
        </div>
        <SectionCTA
          title="Schedule time to meet the team and explore fit."
          eyebrow="Curious about our approach?"
          buttonText="Meet with the team"
        />
      </section>
      <section className="section-container section-spacing">
        <div className="grid gap-8 md:gap-10 lg:grid-cols-2">
          <Surface className="p-6 md:p-8">
            <h2 className="text-2xl font-semibold text-cam-blue">Our Commitments</h2>
            <ul className="mt-4 space-y-3 text-base text-slate-600">
              <li>Fiduciary duty and fee transparency across every engagement.</li>
              <li>Collaborative partnership with your existing professional team.</li>
              <li>Proactive communication and education built around your cadence.</li>
              <li>Inclusive planning that considers values, family, and legacy.</li>
            </ul>
          </Surface>
          <Surface className="bg-cam-blue/5 p-6 md:p-8">
            <h2 className="text-2xl font-semibold text-cam-blue">Compliance Snapshot</h2>
            <p className="mt-4 text-sm text-slate-600">
              Update this area with your registration status, custodian relationships, insurance disclosures, and any jurisdictional considerations.
            </p>
            <div className="mt-6">
              <RiskDisclosure />
            </div>
          </Surface>
        </div>
      </section>
    </main>
  );
}
